<template>
  <li class="onhover-dropdown">
    <div class="notification-box">
      <svg>
        <use href="@/assets/svg/icon-sprite.svg#notification" @click="notification_open()"></use>
      </svg>
      <span v-if="pendientes.length" class="badge rounded-pill badge-secondary">{{ pendientes.length }}</span>
    </div>
    <div
      class="onhover-show-div notification-dropdown"
      :class="{ active: notification }"
    >
      <h6 class="f-18 mb-0 dropdown-title">Notificaciones</h6>
      <ul>
        <li v-if="loading"><p class="mb-0">Cargando...</p></li>
        <li v-if="!loading && pendientes.length === 0"><p class="mb-0">No hay notificaciones pendientes</p></li>
        <li
          v-for="item in pendientes"
          :key="item.id"
          class="notification-item"
          :style="{ borderLeft: `4px solid ${tipoColor(item.tipo)}` }"
          @click="toggleExpand(item.id)"
        >
          <div class="d-flex justify-content-between align-items-start">
            <p class="mb-0 f-w-600">{{ item.titulo }}</p>
            <button
              type="button"
              class="btn btn-xs btn-light icon-btn ms-2"
              title="Marcar como enterado"
              :disabled="markingIds.includes(item.id)"
              @click.stop="marcarVista(item)"
            >
              <vue-feather type="check" size="14"></vue-feather>
            </button>
          </div>
          <p v-if="expandedId === item.id" class="mb-0 mt-1 notification-desc">{{ item.descripcion }}</p>
        </li>
        <li><router-link class="f-w-700" :to="{ name: 'notificaciones' }">Revisar todas</router-link></li>
      </ul>
    </div>
  </li>
</template>

<script>
import api from '@/axios';
import { fetchAllItems } from '@/utils/listResponse';
import { useGeneralStore } from '@/stores/generalStore';
import { getTipoColor } from '@/constants/notificaciones';

function getField(item, key) {
  const found = Object.keys(item).find(k => k.toLowerCase() === key.toLowerCase());
  return found ? item[found] : undefined;
}

export default {
  name: 'Notifications',
  data() {
    return {
      notification: false,
      loading: false,
      pendientes: [],
      expandedId: null,
      markingIds: [],
    };
  },
  computed: {
    usuarioId() {
      return useGeneralStore().id;
    },
  },
  created() {
    this.loadPendientes();
  },
  methods: {
    notification_open() {
      this.notification = !this.notification;
    },

    tipoColor(tipo) {
      return getTipoColor(tipo);
    },

    toggleExpand(id) {
      this.expandedId = this.expandedId === id ? null : id;
    },

    async loadPendientes() {
      if (!this.usuarioId) return;
      try {
        this.loading = true;
        const { items: data } = await fetchAllItems(`notificaciones/pendientes/${this.usuarioId}`);
        this.pendientes = data.map(item => ({
          id: getField(item, 'id'),
          titulo: getField(item, 'titulo'),
          descripcion: getField(item, 'descripcion'),
          tipo: getField(item, 'tipo'),
        }));
      } catch (err) {
        console.error('Error al cargar notificaciones pendientes:', err);
      } finally {
        this.loading = false;
      }
    },

    async marcarVista(item) {
      if (this.markingIds.includes(item.id)) return;
      try {
        this.markingIds.push(item.id);
        await api.post(`notificaciones/${item.id}/vista/${this.usuarioId}`);
        this.pendientes = this.pendientes.filter(p => p.id !== item.id);
        if (this.expandedId === item.id) this.expandedId = null;
      } catch (err) {
        console.error('Error al marcar la notificación como vista:', err);
      } finally {
        this.markingIds = this.markingIds.filter(id => id !== item.id);
      }
    },
  },
};
</script>

<style scoped>
.notification-item {
  cursor: pointer;
}
.icon-btn {
  width: 26px;
  height: 26px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.notification-desc {
  font-size: 12px;
  white-space: normal;
}
</style>
